<template>
  <div>
    <b-row class="mt-4" v-if="data.info">
      <template v-if="data.name=='Outside their Allowed Discrepancy'">
        <b-col md="1" class="r-text-center r-mb-20">
          <img class="mt-3" src="../assets/icons/iconGeneralAgentInfo.svg" alt="bank" />
        </b-col>
        <b-col md="5">
          <div class="d-flex">
            <div class="gray-text width-200">Date Created</div>
            <div class="d-inline-block">
              <print :text="data.info['Date Created']" />
            </div>
          </div>
          <div class="d-flex">
            <div class="gray-text width-200">Bank Name</div>
            <div class="d-inline-block">
              <router-link :to="'/owner/bank/'+data.bank_lmt.bank.user_id">
                <print :text="data.bank_lmt.bank['name']" />
              </router-link>
            </div>
          </div>
          <div class="d-flex">
            <div class="gray-text width-200">{{ $t('general.lmt_name') }}</div>
            <div class="d-inline-block">
              <router-link :to="'/owner/lmt/'+data.lmt_id">
                <print :text="data.info['LMT']" />
              </router-link>
            </div>
          </div>
          <div class="d-flex">
            <div class="gray-text width-200">Street</div>
            <div class="d-inline-block">
              <print :text="data.info['Street']" />
            </div>
          </div>
        </b-col>
        <b-col md="6">
          <div class="d-flex">
            <div class="gray-text width-200">City</div>
            <div class="d-inline-block">
              <print :text="data.info['City']" />
            </div>
          </div>
          <div class="d-flex">
            <div class="gray-text width-200">State</div>
            <div class="d-inline-block">
              <print :text="data.info['State']" />
            </div>
          </div>
          <div class="d-flex">
            <div class="gray-text width-200">Zip Code</div>
            <div class="d-inline-block">
              <print :text="data.info['Zip Code']" />
            </div>
          </div>
        </b-col>
      </template>
      <template v-if="data.name!='Outside their Allowed Discrepancy'&&data.agent">
        <b-col md="1" class="r-text-center r-mb-20">
          <img class="mt-3" src="../assets/icons/iconGeneralAgentInfo.svg" alt="bank" />
        </b-col>
        <b-col md="5">
          <div class="d-flex">
            <div class="gray-text width-200">Date Created</div>
            <div class="d-inline-block">
              <print :text="data.info['Date Created']" />
            </div>
          </div>
          <div class="d-flex">
            <div class="gray-text width-200">Bank Name</div>
            <div class="d-inline-block">
              <router-link :to="'/owner/bank/'+data.bank_lmt.bank.user_id">
                <print :text="data.bank_lmt.bank['name']" />
              </router-link>
            </div>
          </div>         
          <div class="d-flex">
            <div class="gray-text width-200">{{ $t('general.lmt_name') }}</div>
            <div class="d-inline-block">
              <router-link :to="'/owner/lmt/'+data.bank_lmt.lmt.id">
                <print :text="data.bank_lmt.lmt['name']" />
              </router-link>
            </div>
          </div>
           <div class="d-flex">
            <div class="gray-text width-200">{{ $t('general.agent_name') }}</div>
            <div class="d-inline-block">
              <router-link :to="'/owner/agents/'+data.agent.id">
                <print :text="data.agent['name']" />
              </router-link>
            </div>
          </div>
        </b-col>
        <b-col md="6">
           <div class="d-flex">
            <div class="gray-text width-200">Street</div>
            <div class="d-inline-block">
              <print :text="data.info['Street']" />
            </div>
          </div>
          <div class="d-flex">
            <div class="gray-text width-200">City</div>
            <div class="d-inline-block">
              <print :text="data.info['City']" />
            </div>
          </div>
          <div class="d-flex">
            <div class="gray-text width-200">State</div>
            <div class="d-inline-block">
              <print :text="data.info['State']" />
            </div>
          </div>
          <div class="d-flex">
            <div class="gray-text width-200">Zip Code</div>
            <div class="d-inline-block">
              <print :text="data.info['Zip Code']" />
            </div>
          </div>
        </b-col>
      </template>
      <template v-if="data.name!='Outside their Allowed Discrepancy'&&data.agent===null">
        <b-col md="1" class="r-text-center r-mb-20">
          <img class="mt-3" src="../assets/icons/iconGeneralAgentInfo.svg" alt="bank" />
        </b-col>
        <b-col md="5">
          <div class="d-flex">
            <div class="gray-text width-200">Date Created</div>
            <div class="d-inline-block">
              <print :text="data.info['Date Created']" />
            </div>
          </div>
          <div class="d-flex">
            <div class="gray-text width-200">Bank Name</div>
            <div class="d-inline-block">
              <router-link :to="'/owner/bank/'+data.bank_lmt.bank.user_id">
                <print :text="data.bank_lmt.bank['name']" />
              </router-link>
            </div>
          </div>         
          <div class="d-flex">
            <div class="gray-text width-200">Street</div>
            <div class="d-inline-block">
              <print :text="data.info['Street']" />
            </div>
          </div>
        </b-col>
        <b-col md="6">
          <div class="d-flex">
            <div class="gray-text width-200">City</div>
            <div class="d-inline-block">
              <print :text="data.info['City']" />
            </div>
          </div>
          <div class="d-flex">
            <div class="gray-text width-200">State</div>
            <div class="d-inline-block">
              <print :text="data.info['State']" />
            </div>
          </div>
          <div class="d-flex">
            <div class="gray-text width-200">Zip Code</div>
            <div class="d-inline-block">
              <print :text="data.info['Zip Code']" />
            </div>
          </div>
        </b-col>
      </template>
    </b-row>
  </div>
</template>
<script>
export default {
  props: ["data"]
};
</script>